    
<template>
  <common-page-layout>     
    <large-button-wide class="w3-theme-dark" @click="$router.push('common')">Edit Common</large-button-wide>     
    <large-button-wide class="w3-theme-dark" @click="$router.push('businesslinks')">Links</large-button-wide>         
    <large-button-wide class="w3-theme-dark" @click="$router.push('staff')">Manage Staff</large-button-wide>
  </common-page-layout>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {       
      }
    },
    methods: {      
    },
    computed: {
      ...mapGetters(["business"])      
    }
  
  };
</script>
 


// WEBPACK FOOTER //
// src/components/admin/Admin.vue